import {
	Component,
	Input,
	OnInit
} from '@angular/core';

@Component( {
	selector: 'app-info',
	templateUrl: './info.component.html',
	styleUrls: [ './info.component.scss' ]
} )
export class InfoComponent implements OnInit {

	@Input() hideInfoText = false;

	@Input() hideInfoIcon = false;

	@Input() infoText = '';

	@Input() disableHoverStyle = false;

	@Input() disableFocusStyle = false;

	@Input() baseClass = '';

	@Input() iconClass = 'icon-info';

	@Input() textClass = '';

	constructor() { }

	ngOnInit() {}
}
